import React from 'react';
import './footer.css';
import Logo from "../../Assets/logo.png";
import { FaWhatsapp, FaFacebookF, FaLinkedinIn, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-logo-section">
                    <img
                        src={Logo}
                        alt="Datagreffe Justice Logo"
                        className="footer-logo"
                    />
                    <p className="footer-tagline">
                        La première plateforme juridique ivoirienne qui associe technologie et intelligence artificielle.
                    </p>
                    <div className="social-icons">
                        <a href="#" className="social-icon">
                            <FaWhatsapp />
                        </a>
                        <a href="https://www.linkedin.com/company/datagreffe/" className="social-icon">
                            <FaLinkedinIn />
                        </a>
                    </div>
                </div>

                <div className="footer-services-section">
                    <h3 className="footer-heading">Services</h3>
                    <ul className="footer-links">
                        <li><a href="#">Nos sites</a></li>
                        <li><a href="#">Connexion</a></li>
                        <li><a href="#">Inscription</a></li>
                    </ul>
                </div>

                <div className="footer-contact-section">
                    <h3 className="footer-heading">Contact</h3>
                    <ul className="footer-contact-info">
                        <li>
                            <FaEnvelope className="contact-icon" />
                            <span>contact@datagreffe.ci</span>
                        </li>
                        <li>
                            <FaMapMarkerAlt className="contact-icon" />
                            <span>Abidjan, Côte d'Ivoire</span>
                        </li>
                    </ul>
                    <div className="contact-button-container">
                        <button className="contact-button"><a href=" https://share.hsforms.com/1SXK4l2SzQhO01C8yoFWafA32gu0">Nous contacter</a> </button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;